import { cva } from "styled-system/css";

export const buttonCardRecipe = cva({
  base: {
    padding: "300",
    bg: "white",
    display: "flex",
    flexDir: "column",
    gap: "50",
    textAlign: "start",
    borderRadius: "100",
    cursor: "pointer",
    outlineWidth: "1px",
    outlineStyle: "solid",
    outlineColor: "transparent",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "border.light",
    transitionDuration: "normal",
    transitionProperty: "outline, border",
    transitionTimingFunction: "default",
    _hover: {
      outlineColor: "border.mid",
      borderColor: "border.mid",
    },
    _focusVisible: {
      outlineColor: "border.mid",
      borderColor: "border.mid",
    },
    _selected: {
      outlineColor: "border.dark",
      borderColor: "border.dark",
      _hover: {
        outlineColor: "border.dark",
        borderColor: "border.dark",
      },
      _focusVisible: {
        outlineColor: "border.dark",
        borderColor: "border.dark",
      },
    },
  },
});
